(() => {
  const menuButton = document.querySelector('.mobile-menu');
  const categoryNav = document.querySelector('.category-nav');
  if (!menuButton || !categoryNav || menuButton.dataset.bound === 'true') return;

  menuButton.dataset.bound = 'true';
  const closeMenu = () => {
    categoryNav.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-label', 'Open category navigation');
    menuButton.textContent = '☰';
  };

  menuButton.addEventListener('click', () => {
    const open = categoryNav.classList.toggle('is-open');
    document.body.classList.toggle('menu-open', open);
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? 'Close category navigation' : 'Open category navigation');
    menuButton.textContent = open ? '×' : '☰';
  });

  categoryNav.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeMenu();
  });
})();

(() => {
  const amazonAttribution = Object.freeze({
    sheet420: { maas: 'maas_adg_19564C68BDD32581A2A41792997DCDA1_afap_abs', ref_: 'aa_maas', tag: 'maas' },
    sheet600: { maas: 'maas_adg_68DB9170AE1AD9D752EF1473FCDE461F_afap_abs', ref_: 'aa_maas', tag: 'maas' },
    mesh: { maas: 'maas_adg_B3B443F132E85DA624ACACF0C12E4621_afap_abs', ref_: 'aa_maas', tag: 'maas' },
    muzzle: { maas: 'maas_adg_5B30F9544E3E2381563F5029B5E7B01B_afap_abs', ref_: 'aa_maas', tag: 'maas' },
    flyMask: { maas: 'maas_adg_D80B796333904CCAD643757AEB1E2A55_afap_abs', ref_: 'aa_maas', tag: 'maas' },
    girth: { maas: 'maas_adg_FFC2A9F99E41190878A22D35708B16F3_afap_abs', ref_: 'aa_maas', tag: 'maas' }
  });
  const primaryAsinFamilies = Object.freeze({
    B0G5XHM4F1: 'sheet420',
    B0G5KN8KHF: 'sheet600',
    B0GZF4K152: 'mesh',
    B0D7VTPMLD: 'muzzle',
    B0GHSRGFVK: 'flyMask',
    B0GTKF953S: 'girth'
  });
  const googleAdsSignal = () => {
    const params = new URLSearchParams(window.location.search);
    const source = (params.get('utm_source') || '').toLowerCase();
    const medium = (params.get('utm_medium') || '').toLowerCase();
    return params.has('gclid') || params.has('gbraid') || params.has('wbraid') || params.has('gad_source') ||
      ((source === 'google' || source === 'googleads' || source === 'google_adwords') && ['cpc', 'ppc', 'paid', 'paid_search', 'paidsearch'].includes(medium));
  };
  const googleAdsSession = (() => {
    try {
      if (googleAdsSignal()) sessionStorage.setItem('barnStableGoogleAdsVisit', '1');
      return sessionStorage.getItem('barnStableGoogleAdsVisit') === '1';
    } catch (error) {
      return googleAdsSignal();
    }
  })();
  const asinFromUrl = href => href.match(/\/dp\/([A-Z0-9]{10})/i)?.[1]?.toUpperCase() || '';
  const attributionFamily = link => {
    const explicitFamily = link.dataset.attributionFamily || link.closest('[data-attribution-family]')?.dataset.attributionFamily || link.closest('[data-family]')?.dataset.family;
    if (explicitFamily && amazonAttribution[explicitFamily]) return explicitFamily;
    const asin = asinFromUrl(link.href);
    if (primaryAsinFamilies[asin]) return primaryAsinFamilies[asin];
    const group = window.BARN_STABLE_LX_CATALOG?.groups?.find(candidate =>
      candidate.items?.some(item => item.asin === asin) || candidate.parents?.includes(asin)
    );
    return group && amazonAttribution[group.family] ? group.family : '';
  };
  const prepareAmazonLink = link => {
    if (!googleAdsSession || !link || !link.href.includes('amazon.com/')) return { applied: false, family: '' };
    const family = attributionFamily(link);
    const attribution = amazonAttribution[family];
    if (!attribution) return { applied: false, family };
    const destination = new URL(link.href);
    Object.entries(attribution).forEach(([key, value]) => destination.searchParams.set(key, value));
    link.href = destination.href;
    link.dataset.amazonAttributionApplied = 'true';
    return { applied: true, family };
  };

  ['pointerdown', 'contextmenu'].forEach(type => document.addEventListener(type, event => {
    prepareAmazonLink(event.target.closest('a[href*="amazon.com/"]'));
  }));

  document.addEventListener('click', event => {
    const link = event.target.closest('a[href*="amazon.com/"]');
    if (!link) return;
    const attribution = prepareAmazonLink(link);
    const asin = asinFromUrl(link.href);
    const eventData = {
      event_category: 'outbound',
      link_url: link.href,
      product_asin: asin,
      page_location: window.location.href,
      amazon_attribution_applied: attribution.applied || link.dataset.amazonAttributionApplied === 'true',
      attribution_family: attribution.family || attributionFamily(link),
      traffic_source: googleAdsSession ? 'google_ads' : 'unattributed'
    };
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'amazon_outbound_click', ...eventData });
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'amazon_outbound_click', eventData);
      const tracking = window.BARN_STABLE_TRACKING || {};
      if (tracking.googleAdsId && tracking.googleAdsLabel) {
        window.gtag('event', 'conversion', { send_to: `${tracking.googleAdsId}/${tracking.googleAdsLabel}`, value: 1, currency: 'USD' });
      }
    }
  });
})();
